/** @format */

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from "@mui/material";
import SortableTableHeader from "../reusables/table/SortableTableHeader";
import React, { useEffect, useState } from "react";
import Iconify from "./Iconify";
import { LoadingButton } from "@mui/lab";
import IconButton from "@mui/material/IconButton";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import { Row } from "react-bootstrap";
import Col from "react-bootstrap/cjs/Col";

import { FaAngleDown, FaTrash } from "react-icons/fa";
import Stack from "@mui/material/Stack";
import {
  applySortFilter,
  getComparator,
} from "../reusables/table/SortFilterUtils";
import Waba from "../dao/Waba";

import DialogContentText from "@mui/material/DialogContentText";
import Select, { components } from "react-select";

const TABLE_HEAD = [
  { id: "count", label: "No.", alignRight: false, sortable: false },
  { id: "name", label: "Name", alignRight: false, sortable: true },
  { id: "waba_id", label: "WABA ID", alignRight: false, sortable: true },

  // {id: 'role', label: 'Role', alignRight: false, sortable: true},
];

const DropdownIndicator = (props) => {
  return (
    components.DropdownIndicator && (
      <components.DropdownIndicator {...props}>
        <FaAngleDown color={"grey"} />
      </components.DropdownIndicator>
    )
  );
};

export default function WABAForm(props) {
  const [selectedWaba, setSelectedWaba] = useState(null);
  const [wabaSelection, setWabaOptions] = useState([]);
  // const [selectedRole, setSelectedRole] = useState(null)

  const { wabas, setWabas, assignedWaba } = props;

  // const [wabaName, setWabaName] = useState(null)
  //   const [wabaID, setWabaID] = useState("");
  const [setWabaID] = useState("");
  //   const [page, setPage] = useState(0);
  const [page] = useState(0);
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("waba_id");
  //   const [filterName, setFilterName] = useState("");
  //   const [rowsPerPage, setRowsPerPage] = useState(10);
  const [filterName] = useState("");
  const [rowsPerPage] = useState(10);

  //   const [isDataFetched, setIsDataFetched] = useState(true);

  const [isAddingWABA, setIsAddingWABA] = useState(false);

  // const [wabas, setWabas] = useState([])

  useEffect(() => {
    getWabas();
  }, []);

  const getWabas = async () => {
    try {
      let result = await Waba.getMyWaba();
      // console.log("MW", result);
      //let templates = result.map((el) => ({...el.profile, role: el.role}));

      let formatted = result.map((obj) => {
        return {
          label: `${obj.name} (${obj.waba_id})`,
          value: obj.waba_id,
        };
      });

      setWabaOptions(formatted);
    } catch (e) {
      // nothing
    }
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const sortedWABA = applySortFilter(
    wabas,
    getComparator(order, orderBy),
    filterName
  );

  return (
    <>
      <Typography
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "flex-start",
        }}
        variant="h6"
      >
        <div>Assign WABA</div>
        <IconButton
          onClick={() => {
            setIsAddingWABA(true);
          }}
          size="small"
          type="button"
          variant="contained"
        >
          <Iconify icon="eva:plus-fill" width={22} height={22} />
        </IconButton>
      </Typography>

      <TableContainer sx={{ minWidth: 800 }}>
        <Table style={{backgroundColor:'red', color: 'white',}}>
          <SortableTableHeader
            order={order}
            orderBy={orderBy}
            headLabel={TABLE_HEAD}
            onRequestSort={handleRequestSort}
          />
          <TableBody>
            {wabas
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((item, key) => {
                if (!item) {
                  return <>boi</>;
                }
                return (
                  <TableRow hover key={key} tabIndex={-1} role="checkbox">
                    <TableCell align="left">{key + 1}</TableCell>
                    <TableCell align="left">{`${item.name}`}</TableCell>
                    <TableCell align="left">{`${item.waba_id}`}</TableCell>
                    {/*<TableCell align="left">{item.role}</TableCell>*/}
                    <TableCell align="right">
                      <IconButton
                        onClick={() => {
                          setWabas(
                            wabas.filter(
                              (waba) => waba.waba_id !== item.waba_id
                            )
                          );
                        }}
                        size="small"
                        type="button"
                        variant="contained"
                      >
                        <FaTrash />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                );
              })}
          </TableBody>
          {sortedWABA.length === 0 && (
            <TableBody>
              <TableRow>
                <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                  <LoadingButton
                    onClick={() => {
                      setIsAddingWABA(true);
                    }}
                    size="small"
                    variant="contained"
                  >
                    <Iconify
                      icon="eva:plus-fill"
                      width={22}
                      height={22}
                      sx={{ marginRight: 1 }}
                    />
                    Assign WABA
                  </LoadingButton>
                </TableCell>
              </TableRow>
            </TableBody>
          )}
        </Table>
      </TableContainer>

      <Dialog
        fullWidth={true}
        maxWidth={"sm"}
        open={isAddingWABA}
        onClose={() => setIsAddingWABA(false)}
      >
        <DialogTitle>Assign Whatsapp Business Account</DialogTitle>
        <DialogContent>
          <Stack spacing={3}>
            {/*<TextField*/}
            {/*    style={{*/}
            {/*        marginTop : 5*/}
            {/*    }}*/}
            {/*    fullWidth*/}
            {/*    label="Name"*/}
            {/*    InputLabelProps={{ shrink: true }}*/}
            {/*/>*/}
            {/*<TextField*/}
            {/*    style={{*/}
            {/*        marginTop: 5*/}
            {/*    }}*/}
            {/*    value={wabaID}*/}
            {/*    onChange={(e) => {*/}
            {/*        setWabaID(e.target.value)*/}
            {/*    }}*/}
            {/*    fullWidth*/}
            {/*    label="WABA ID"*/}
            {/*    InputLabelProps={{shrink: true}}*/}
            {/*/>*/}
          </Stack>

          <Row>
            <Col md={12}></Col>
          </Row>

          <Row>
            <Col md={12}></Col>
          </Row>

          <DialogContentText>Whatsapp Business Account</DialogContentText>
          <Row>
            <Col md={12}>
              <Select
                menuPortalTarget={document.body}
                onChange={(option) => {
                  setSelectedWaba(option);
                  setWabaID(option.value);
                }}
                placeholder={"WABA"}
                value={selectedWaba}
                options={wabaSelection.filter((obj) => {
                  return !assignedWaba
                    .map((obj) => obj.waba_id)
                    .includes(obj.value);
                })}
                styles={{
                  option: (provided, state) => ({
                    ...provided,
                    cursor: "pointer",
                  }),
                  control: (provided) => ({
                    ...provided,
                    borderColor: "#e6e6e6",
                  }),
                  container: (provided) => ({
                    ...provided,
                    width: "100%",
                  }),
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  menu: (provided) => ({
                    ...provided,
                    zIndex: "9999 !important",
                  }),
                }}
                components={{
                  DropdownIndicator,
                  IndicatorSeparator: () => null,
                }}
              />
            </Col>
          </Row>

          {/*<DialogContentText style={{*/}
          {/*    marginTop : 10*/}
          {/*}}>*/}
          {/*    Permission*/}
          {/*</DialogContentText>*/}
          {/*<Row>*/}
          {/*    <Col md={12}>*/}
          {/*        <Select*/}
          {/*            onChange={(option) => {*/}
          {/*                setSelectedRole(option)*/}
          {/*            }}*/}
          {/*            placeholder={'Role'}*/}
          {/*            value={selectedRole}*/}
          {/*            options={roleSelection}*/}
          {/*            menuPortalTarget={document.querySelector('body')}*/}
          {/*            styles={{*/}
          {/*                option: (provided, state) => ({*/}
          {/*                    ...provided,*/}
          {/*                    cursor: 'pointer',*/}
          {/*                }),*/}
          {/*                control: provided => ({*/}
          {/*                    ...provided,*/}
          {/*                    borderColor: '#e6e6e6'*/}
          {/*                }),*/}
          {/*                container : provided =>({*/}
          {/*                    ...provided,*/}
          {/*                    width : "100%"*/}
          {/*                }),*/}
          {/*                menuPortal: base => ({...base, zIndex: 9999}),*/}
          {/*                menu: provided => ({...provided, zIndex: "9999 !important"})*/}
          {/*            }}*/}
          {/*            components={{DropdownIndicator, IndicatorSeparator: () => null}}*/}
          {/*        />*/}
          {/*    </Col>*/}
          {/*</Row>*/}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setWabas([
                ...wabas,
                {
                  name: selectedWaba.label.replace(/\((.*?)\)/g, ""),
                  waba_id: selectedWaba.value,
                },
              ]);
              setWabaID("");
              setSelectedWaba(null);
              setIsAddingWABA(false);
            }}
          >
            Add
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
